import React from 'react'
import TenantTableItem from "./TenantTableItem"

const TenantTableBody = (props) => {
    const {error, listTenantDealer} = props

    return (
        <tbody className="TableBody">
        {
            listTenantDealer && listTenantDealer?.length > 0 ? listTenantDealer.map((item, index) => (
                <TenantTableItem
                    index={index}
                    item={item}
                />
            )) : <tr className="NoRecord">
                <td colSpan={6}>Không có bản ghi nào</td>
            </tr>
        }

        {
            error && error.length > 0 && <tr className="NoRecord Error">
                <td colSpan={6}>{error}</td>
            </tr>
        }
        </tbody>
    )
}

export default TenantTableBody
